import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:3000/api';
const API_KEY = process.env.REACT_APP_API_KEY ?? 'better-dog-api-key-2024';

export interface RedeemCouponRequest {
  batchId: string;
  name: string;
  phone: string;
  email: string;
  bairro: string;
}

export interface RedeemCouponResponse {
  code: string;
  value: number;
  minOrderValue: number;
  expiresAt?: string;
}

export interface ActiveCouponBatchResponse {
  batchId: string;
  cnpj: string;
  totalAmount: number;
  remainingAmount: number;
  allowedValues: number[];
  minOrderValue: number;
  status: string;
  startsAt?: string;
  expiresAt?: string;
}

export interface ValidateCouponRequest {
  code: string;
  phone: string;
  orderAmount: number;
}

export interface ValidateCouponResponse {
  value: number;
  minOrderValue: number;
}

export const redeemCoupon = async (cnpj: string, payload: RedeemCouponRequest): Promise<RedeemCouponResponse> => {
  const response = await axios.post<RedeemCouponResponse>(`${API_URL}/coupons/redeem`, payload, {
    headers: {
      'Content-Type': 'application/json',
      'x-company-cnpj': cnpj,
      'x-api-key': API_KEY,
    },
  });
  return response.data;
};

export const fetchActiveCouponBatch = async (cnpj: string): Promise<ActiveCouponBatchResponse | null> => {
  const response = await axios.get<ActiveCouponBatchResponse>(`${API_URL}/coupons/active-batch`, {
    headers: {
      'x-company-cnpj': cnpj,
      'x-api-key': API_KEY,
    },
  });
  return response.data;
};

export const validateCoupon = async (
  cnpj: string,
  payload: ValidateCouponRequest,
): Promise<ValidateCouponResponse> => {
  const response = await axios.post<ValidateCouponResponse>(
    `${API_URL}/coupons/validate`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        'x-company-cnpj': cnpj,
        'x-api-key': API_KEY,
      },
    },
  );
  return response.data;
};
